var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _ellipse, _ellipse2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultProfileOrangeCat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1345,
    height: 948,
    viewBox: "0 0 1345 948",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M672.149 296.007L474.588 156.623C474.588 156.623 173.386 -12.9852 158.994 156.623C144.601 326.231 228.075 491.95 228.075 491.95L397.897 638.747L672.149 296.007Z",
    fill: "#FF9900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M575.264 304.675L435.322 205.943C435.322 205.943 221.967 85.8016 211.772 205.943C201.577 326.084 260.705 443.471 260.705 443.471L380.998 547.453L575.264 304.675Z",
    fill: "#CC748F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M672.15 296.007L869.712 156.623C869.712 156.623 1170.91 -12.9852 1185.31 156.623C1199.7 326.231 1116.23 491.95 1116.23 491.95L946.403 638.747L672.15 296.007Z",
    fill: "#FF9900"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M757.15 304.675L897.092 205.943C897.092 205.943 1110.45 85.8016 1120.64 205.943C1130.84 326.084 1071.71 443.471 1071.71 443.471L951.416 547.453L757.15 304.675Z",
    fill: "#CC748F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1146 576C1146 841.968 886.584 949.554 660.252 947C437.767 944.489 166 865.967 166 576C166 286.033 396.818 127 660.252 127C923.687 127 1146 286.033 1146 576Z",
    fill: "#FF9900"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M362 517C362 478.892 392.892 448 431 448V448C469.108 448 500 478.892 500 517V517C500 555.108 469.108 586 431 586V586C392.892 586 362 555.108 362 517V517Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M362 517C362 478.892 392.892 448 431 448V448C469.108 448 500 478.892 500 517V517C500 555.108 469.108 586 431 586V586C392.892 586 362 555.108 362 517V517Z",
    fill: "#151414"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M831 517C831 478.892 861.892 448 900 448V448C938.108 448 969 478.892 969 517V517C969 555.108 938.108 586 900 586V586C861.892 586 831 555.108 831 517V517Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M831 517C831 478.892 861.892 448 900 448V448C938.108 448 969 478.892 969 517V517C969 555.108 938.108 586 900 586V586C861.892 586 831 555.108 831 517V517Z",
    fill: "#151414"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 655.5,
    cy: 732,
    rx: 163.5,
    ry: 78,
    fill: "#FDEFEF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 656,
    cy: 693,
    rx: 66,
    ry: 39,
    fill: "#CC748F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 236.418,
    height: 28.6231,
    rx: 14.3115,
    transform: "matrix(-0.875281 0.483614 0.700521 0.713632 316.588 721)",
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 236.418,
    height: 28.6231,
    rx: 14.3115,
    transform: "matrix(-0.9838 0.179268 0.436397 0.899754 296.147 653)",
    fill: "#C4C4C4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 236.418,
    height: 28.6231,
    rx: 14.3115,
    transform: "matrix(-0.989724 -0.142992 0.127516 0.991837 293.988 578.806)",
    fill: "#C4C4C4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 236.418,
    height: 28.6231,
    rx: 14.3115,
    transform: "matrix(0.875281 0.483614 -0.700521 0.713632 989.051 734)",
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 236.418,
    height: 28.6231,
    rx: 14.3115,
    transform: "matrix(0.9838 0.179268 -0.436397 0.899754 1009.49 666)",
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 236.418,
    height: 28.6231,
    rx: 14.3115,
    transform: "matrix(0.989724 -0.142992 -0.127516 0.991837 1011.65 591.806)",
    fill: "#C4C4C4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 435,
    cy: 516,
    r: 69,
    fill: "#262626"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 516,
    r: 69,
    fill: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileOrangeCat);
export default __webpack_public_path__ + "static/media/default-profile-orange-cat.ba59631f.svg";
export { ForwardRef as ReactComponent };